var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"overflow-x-auto flex-nowrap"},_vm._l((_vm.variables),function(variable,index){return _c('v-col',{key:index},[_c('v-btn',{attrs:{"outlined":"","color":"primary"},on:{"click":function($event){return _vm.$emit('sendCode', variable.code)}}},[_vm._v(" "+_vm._s(variable.name)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }